/**
 * Telegram HapticFeedback helper.
 * Falls back silently when running outside Telegram.
 */
export function useHaptic() {
  const haptic = window.Telegram?.WebApp?.HapticFeedback

  return {
    /** Лёгкий тап — смена вкладки, открытие/закрытие */
    light:   () => haptic?.impactOccurred('light'),
    /** Средний тап — переключение тогла */
    medium:  () => haptic?.impactOccurred('medium'),
    /** Тяжёлый тап — удаление */
    heavy:   () => haptic?.impactOccurred('heavy'),
    /** Успех — сохранение настроек */
    success: () => haptic?.notificationOccurred('success'),
    /** Предупреждение — деструктивное действие */
    warning: () => haptic?.notificationOccurred('warning'),
    /** Ошибка */
    error:   () => haptic?.notificationOccurred('error'),
  }
}
